<template>
  <div class="container">
    <div class="main">
      <div class="square-decoration"></div>
      <div class="square-decoration down"></div>
      <div class="main-text">
        <h1 class="title">电子公证书查验中心</h1>
        <div class="desc">
          公证书查验是对电子公证书的有效性进行验证，<br />帮助您核验电子公证书及材料附件的<a
            class="hightlight"
            >真实性</a
          >和<a class="hightlight">有效性</a>
        </div>
      </div>
      <div class="main-decoration">
        <img src="../assets/images/main_decoration.svg" alt="" />
      </div>
    </div>
    <div class="validation">
      <div class="tabs-list">
        <div
          class="tabs-item"
          :class="{ active: checkType === 'hash' }"
          @click="checkType = 'hash'"
        >
          哈希值验证
        </div>
        <div
          class="tabs-item"
          :class="{ active: checkType === 'file' }"
          @click="checkType = 'file'"
        >
          上传文件校验
        </div>
      </div>
      <div class="tab-content">
        <template v-if="checkType === 'hash'">
          <div class="input-wrap">
            <input
              class="input"
              type="text"
              v-model="code"
              @input="codeChange"
              placeholder="请输入电子公证书哈希值前十二位进行验证"
            />
            <div class="btn" @click="startCodeCheck()">开始验证</div>
          </div>
          <!-- <div class="help">
            <a>如何获取电子公证书哈希值？</a>
          </div> -->
        </template>

        <template v-if="checkType === 'file'">
          <template v-if="loading">
            <div class="loading">
              <loading-one
                class="loading-icon"
                theme="outline"
                size="30"
                fill="#4d6de3"
              />
            </div>
          </template>
          <div
            v-else
            class="upload-btn"
            v-bind:class="{ active: uploadActive }"
            @click="fileClick()"
            @drop="fileDrop($event)"
            @dragover="fileOver($event)"
            @dragleave="fileLeave($event)"
          >
            点击上传电子公证书进行查验，文件大小不超过10M
          </div>
          <input
            ref="File"
            type="file"
            style="display: none"
            @change="startFileCheck($event)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { LoadingOne } from "@icon-park/vue";

export default {
  components: {
    LoadingOne,
  },
  data: function () {
    return {
      uploadActive: false,
      checkType: "hash",
      code: null,
      file: null,
      loading: false,
    };
  },
  methods: {
    startCodeCheck() {
      if (!this.code) {
        alert("请输入电子公证书哈希值前十二位进行验证");
        return;
      }
      const code = this.code.replaceAll("-", "");
      const reg = /^[a-zA-Z0-9]+$/;
      if (!reg.test(code)) {
        alert("电子公证书哈希值应为英文字母及数字");
        return;
      }
      const params = {
        code,
      };
      this.$api.checkFingerprintByCode(params).then((res) => {
        if (!res.code) {
          throw new Error("网络异常");
        }
        sessionStorage.setItem("checkResult", JSON.stringify(res["result"]));
        this.$router.push("/result");
      });
    },
    startFileCheck(event) {
      const file = event.target.files[0];
      this.uploadWithCheck(file);
    },
    uploadWithCheck(file) {
      if (file.size > 1024 * 1024 * 10) {
        alert("仅支持10MB以下文件上传");
        return;
      }
      // 校验文件类型
      const filename = file.name;
      const suffix = filename.substring(filename.lastIndexOf('.') + 1);
      if (suffix !== 'pdf') {
        alert("仅支持pdf文件上传");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      this.loading = true;
      fetch("/backend/service/rest/tk.File/collection/upload", {
        method: "POST",
        body: formData,
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          } else {
            throw new Error("网络异常");
          }
        })
        .then((res) => {
          const params = {
            fileId: res.fileId,
          };
          return this.$api.checkFingerprintByFile(params);
        })
        .then((res) => {
          if (!res.code) {
            throw new Error("网络异常");
          }
          sessionStorage.setItem("fileName", file.name);
          if (res["result"] && res["result"]) {
            sessionStorage.setItem("checkResult", JSON.stringify(res["result"]));
          }
          this.$router.push("/result");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 拖拽结束
    fileDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (files && files.length) {
        this.uploadWithCheck(files[0]);
      }
    },
    // 拖拽经过
    fileOver(event) {
      this.uploadActive = true;
      event.preventDefault();
    },
    fileLeave(event) {
      this.uploadActive = false;
      event.preventDefault();
    },
    fileClick() {
      this.$refs.File.click();
    },
    codeChange() {
      const reg = /[0-9a-zA-Z]{1,4}/g;
      const found = this.code.match(reg);
      this.code = found.join("-");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
}
.main {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 48px;
  .square-decoration {
    position: absolute;
    top: 56px;
    left: 0;
    width: 84px;
    height: 80px;
    background: url("../assets/images/square_decoration.svg") top left no-repeat;
    opacity: 0.15;
    &.down {
      top: auto;
      left: auto;
      bottom: -240px;
      right: 0;
      filter: grayscale(100%);
    }
  }

  .title {
    position: relative;
    font-size: 48px;
    &::after {
      content: "";
      position: absolute;
      left: 4px;
      bottom: -32px;
      width: 48px;
      border-bottom: 5px solid #383838;
    }
  }
  .desc {
    padding-top: 48px;
    line-height: 36px;
    font-size: 18px;
    font-weight: 300;
    color: rgba($color: #000000, $alpha: 0.65);

    .hightlight {
      color: #4d6de3;
    }
  }
  &-text {
    padding-left: 48px;
  }
  &-decoration {
    padding-top: 24px;
    margin-right: -64px;
  }
}

.validation {
  position: relative;
  margin: 0 auto;
  padding-top: 48px;
  width: 880px;
  padding-bottom: 48px;
  .tabs-list {
    display: flex;
    justify-content: center;
    align-items: center;

    .tabs-item {
      position: relative;
      font-size: 16px;
      color: #383838;
      font-weight: bold;
      cursor: pointer;
      transition: color 0.7s;

      & + .tabs-item {
        margin-left: 60px;
      }

      &.active {
        color: #4d6de3;

        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -15px;
          margin-left: -20px;
          width: 40px;
          border-bottom: 4px solid #4d6de3;
        }
      }
    }
  }

  .tab-content {
    padding-top: 44px;
    width: 880px;
    .input-wrap {
      display: flex;
      justify-content: center;
    }

    .input {
      flex: 1;
      padding: 0 20px;
      font-size: 18px;
      background-color: #f5f5f5;
      font-weight: 300;
      border: none;
      text-transform: uppercase;
      border-radius: 8px 0 0 8px;
      outline: none;
      &::-webkit-input-placeholder {
        color: rgba($color: #000000, $alpha: 0.35);
      }
    }

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 60px;
      background-color: #4d6de3;
      color: #fff;
      font-size: 18px;
      border-radius: 0 8px 8px 0;
      cursor: pointer;
    }

    .upload-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 58px;
      border: 1px dashed rgba($color: #000000, $alpha: 0.15);
      color: rgba($color: #000000, $alpha: 0.35);
      font-size: 18px;
      font-weight: 300;
      background-color: #f5f5f5;
      border-radius: 8px;
      cursor: pointer;
      transition: color 0.6s, border-color 0.6s;
      &:hover,
      &.active {
        color: #4d6de3;
        border-color: #4d6de3;
      }
    }
  }

  .loading {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .loading-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      animation: loadingCircle 2s infinite linear;
    }
  }

  .help {
    padding-top: 23px;
    font-size: 14px;
    color: #4d6de3;
    text-align: center;
  }
}

@keyframes loadingCircle {
  100% {
    transform: rotate(1turn);
  }
}
</style>
